export const normalizeRole = (role) => {
  const value = String(role || '').toUpperCase();
  if (value === 'ADMIN') return 'SUPER_ADMIN';
  if (value === 'USER') return 'VENDEDOR';
  return value;
};

export const getLoggedUser = () => {
  try {
    const raw = localStorage.getItem('kardex_user');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.user && typeof parsed.user === 'object') {
      return { ...parsed.user, token: parsed.token || null };
    }
    return parsed;
  } catch (error) {
    return null;
  }
};

export const hasRole = (allowedRoles = [], user = getLoggedUser()) => {
  const role = normalizeRole(user?.role);
  return allowedRoles.map(normalizeRole).includes(role);
};

export const ROLE_ACCESS = {
  SUPER_ADMIN: {
    inventory: ['products', 'suppliers', 'kardex-movements', 'document-register', 'tapers', 'phone-purchases', 'transfers'],
    einvoice: ['invoices', 'quotations', 'guides', 'notes', 'services'],
    carwash: ['dashboard', 'pos', 'orders', 'services', 'employees'],
    users: true
  },
  LOGISTICA: {
    inventory: ['products', 'suppliers', 'kardex-movements', 'document-register', 'tapers', 'phone-purchases', 'transfers'],
    einvoice: ['guides', 'services'],
    carwash: [],
    users: false
  },
  VENDEDOR: {
    inventory: ['products', 'transfers'],
    einvoice: ['invoices', 'quotations', 'notes', 'services'],
    carwash: [],
    users: false
  },
  CARWASH: {
    inventory: [],
    einvoice: [],
    carwash: ['dashboard', 'pos', 'orders', 'services', 'employees'],
    users: false
  }
};

export const isCarwashOnly = (user = getLoggedUser()) =>
  normalizeRole(user?.role) === 'CARWASH';

export const roleLabel = (role) => {
  const map = {
    SUPER_ADMIN: 'Administrador',
    LOGISTICA: 'Logística',
    VENDEDOR: 'Vendedor',
    CARWASH: 'Carwash'
  };
  const key = normalizeRole(role);
  return map[key] || key || '—';
};

export const canPickInventoryStore = (user = getLoggedUser()) =>
  hasRole(['SUPER_ADMIN', 'LOGISTICA'], user);

export const canAccessModule = (section, module, user = getLoggedUser()) => {
  const role = normalizeRole(user?.role);
  const access = ROLE_ACCESS[role];
  if (!access) return false;
  if (section === 'users') return Boolean(access.users);
  return Array.isArray(access[section]) && access[section].includes(module);
};

export const getDefaultSerieForStore = (prefix, storeId, width = 3) => {
  const sid = Number(storeId);
  const safe = Number.isFinite(sid) && sid > 0 ? sid : 1;
  return `${prefix}${String(safe).padStart(width, '0')}`;
};

export const canAccessPath = (path, user = getLoggedUser()) => {
  const pathname = String(path || '');
  const role = normalizeRole(user?.role);

  if (!user || !role) return false;
  if (pathname === '/dashboard') return true;
  if (role === 'CARWASH') {
    return pathname.startsWith('/carwash');
  }
  if (role === 'SUPER_ADMIN') return true;

  if (pathname.startsWith('/inventory/products')) return canAccessModule('inventory', 'products', user);
  if (pathname.startsWith('/inventory/suppliers')) return canAccessModule('inventory', 'suppliers', user);
  if (pathname.startsWith('/inventory/kardex-movements')) return canAccessModule('inventory', 'kardex-movements', user);
  if (pathname.startsWith('/inventory/document-register')) return canAccessModule('inventory', 'document-register', user);
  if (pathname.startsWith('/inventory/transfers')) return canAccessModule('inventory', 'transfers', user);
  if (pathname.startsWith('/inventory/tapers')) return canAccessModule('inventory', 'tapers', user);
  if (pathname.startsWith('/inventory/phone-purchases')) return canAccessModule('inventory', 'phone-purchases', user);

  if (pathname.startsWith('/einvoice/invoices')) return canAccessModule('einvoice', 'invoices', user);
  if (pathname.startsWith('/einvoice/quotations')) return canAccessModule('einvoice', 'quotations', user);
  if (pathname.startsWith('/einvoice/guides')) return canAccessModule('einvoice', 'guides', user);
  if (pathname.startsWith('/einvoice/notes')) return canAccessModule('einvoice', 'notes', user);
  if (pathname.startsWith('/einvoice/services')) return canAccessModule('einvoice', 'services', user);

  if (pathname.startsWith('/carwash/nuevo') || pathname.startsWith('/carwash/pos')) return canAccessModule('carwash', 'pos', user);
  if (pathname.startsWith('/carwash/ordenes')) return canAccessModule('carwash', 'orders', user);
  if (pathname.startsWith('/carwash/servicios')) return canAccessModule('carwash', 'services', user);
  if (pathname.startsWith('/carwash/empleados')) return canAccessModule('carwash', 'employees', user);
  if (pathname.startsWith('/carwash')) return canAccessModule('carwash', 'dashboard', user);

  if (pathname.startsWith('/user-pages/users')) return canAccessModule('users', 'users', user);

  return false;
};
